import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import ImageUploaders from '../tools/uploaderimages';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import HeaderOfPage from '../tools/headerOfPage';

type MultilingualField = Record<string, string>;

const getMultilingualValue = (field: MultilingualField | string | undefined, lang: string): string => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    return (field as MultilingualField)[lang] || '';
};

const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
    if (!field) {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    }
    if (typeof field === 'string') {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = field);
        return obj;
    }
    if (typeof field === 'object') {
        if (field.nl !== undefined) {
            field.ku = field.nl;
            delete field.nl;
        }
        const obj: MultilingualField = { ...field };
        languageCodes.forEach(code => { if (obj[code] == null) obj[code] = ''; });
        return obj;
    }
    const obj: MultilingualField = {};
    languageCodes.forEach(code => obj[code] = '');
    return obj;
};

export default function EditSlider() {
    let cookie = getCookies();
    const { t } = useTranslation();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [activeLang, setActiveLang] = useState<string>('en');
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    const loadLanguages = async (): Promise<Array<{ code: string; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
            if (mapped.length > 0) {
                setActiveLang(mapped[0].code);
            }
            return mapped;
        } catch (e) {
            console.error('Error loading languages:', e);
            const fallback = [
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ];
            setLanguages(fallback);
            return fallback;
        }
    };

    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];

    const [data, setData] = React.useState<any>(null);
    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/slider/${data.id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('Saved');
        } catch (error) {

        }
    }
    const load = async (languageCodes: string[] = []) => {
        try {
            var path = `${config.url}/v1/dashboard/slider/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            let loadedData = res.data.message;
            const codes = languageCodes.length > 0
                ? languageCodes
                : ['ku', 'fa', 'en', 'ar', 'tr'];

            if (loadedData) {
                loadedData.name = initializeMultilingualField(loadedData.name, codes);
                loadedData.title = initializeMultilingualField(loadedData.title, codes);
                loadedData.text = initializeMultilingualField(loadedData.text, codes);
                loadedData.keywords = initializeMultilingualField(loadedData.keywords, codes);
                loadedData.description = initializeMultilingualField(loadedData.description, codes);
            }
            setData(loadedData);
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Blog',
            url: '/dashboard/Blog'
        },
        {
            name: 'Slider List',
            url: '/dashboard/Blog/list'
        },
        {
            name: 'Edit Slider',
            url: null
        }
    ]
    useEffect(() => {
        const initialize = async () => {
            const loadedLanguages = await loadLanguages();
            const languageCodes = loadedLanguages.length > 0
                ? loadedLanguages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            await load(languageCodes);
        };
        initialize();
    }, []);

    useEffect(() => {
        if (languages.length > 0 && data) {
            const languageCodes = languages.map(l => l.code);
            const updatedData = { ...data };
            updatedData.name = initializeMultilingualField(data.name, languageCodes);
            updatedData.title = initializeMultilingualField(data.title, languageCodes);
            updatedData.text = initializeMultilingualField(data.text, languageCodes);
            updatedData.keywords = initializeMultilingualField(data.keywords, languageCodes);
            updatedData.description = initializeMultilingualField(data.description, languageCodes);
            setData(updatedData);
        }
    }, [languages.length]);
    return (
        <div className='directions'>

            <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="ویرایش اسلایدر"></HeaderOfPage>



            {
                data != null && <div className='grid grid-cols-1 sm:grid-cols-5'>
                    <div >

                        <div className=" bg-black rounded-[10px] p-5 text-right">
                            <h4 className="text-white text-[20px] font-bold ">{ t('Edit Slider') }</h4>
                            <hr />
                            <form key={key}>
                                {/* Language Selector */}
                                <div className="max-w-sm space-y-3">
                                    <label className="text-white">زبان / Language</label>
                                    <div className="flex gap-2 flex-wrap">
                                        {langList.map((lang) => (
                                            <button
                                                key={lang.code}
                                                type="button"
                                                onClick={() => setActiveLang(lang.code)}
                                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                                    activeLang === lang.code
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                                }`}
                                            >
                                                {lang.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Name')} ({langList.find(l => l.code === activeLang)?.label})</label>
                                    <input
                                        value={getMultilingualValue(data.name, activeLang)}
                                        type="text"
                                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Name"
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            name: { 
                                                ...data.name, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Slug')}  </label>
                                    <input
                                        type="text"
                                        value={data.url}
                                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                                        placeholder="Slug"
                                        onChange={(e) => setData({ ...data, url: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Title')} ({langList.find(l => l.code === activeLang)?.label})</label>
                                    <input
                                        value={getMultilingualValue(data.title, activeLang)}
                                        type="text"
                                        className={inputstyle}
                                        placeholder="Title"
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            title: { 
                                                ...data.title, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Text')} ({langList.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={getMultilingualValue(data.text, activeLang)}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            text: { 
                                                ...data.text, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Keywords')} ({langList.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={getMultilingualValue(data.keywords, activeLang)}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            keywords: { 
                                                ...data.keywords, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Description')} ({langList.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={getMultilingualValue(data.description, activeLang)}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            description: { 
                                                ...data.description, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <button type="button"
                                        onClick={(e) => { save() }}
                                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                                    >
                                      {t('Update')} 
                                    </button>

                                </div>
                            </form>
                            <div className='mt-3'>
                                <div className="text-white text-left"> {t('Thumpnail')}   </div>
                                <ImageUploader id={data.id} component={'gallerypost'}></ImageUploader>


                            </div>


                        </div>
                    </div>
                    <div className='col-span-1 sm:col-span-4 p-5'>
                        
                                <ImageUploaders count={1000} id={data.id} component={'sliderComponent'}></ImageUploaders>

                                <TissEditor component='sliderpost' parent={data.id} />


                    </div>
                </div>
            }

        </div>
    )
}